function genDefault(options) {
  const nodeOptions = options.nodeOptions;
  const node = options.node;
  const nodeInput = options.nodeInput;
  const constraints = options.constraints;
  const type = options.type;
  const addGenericOption = options.addGenericOption;
  const validName = options.validName;

  const weekdays = [
    "",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];

  nodeOptions.setAttribute("attr", "optionsDefault");

  node.getJson = function () {
    const result = {
      type: type,
      meta: {},
      data: [],
    };

    //meta
    result.meta.label = nodeOptions.querySelector("input[name=label]").value;
    result.meta.name = nodeOptions.querySelector("input[name=name]").value;

    //data
    const allInputTables = nodeInput.querySelectorAll("table");
    let i = 0;
    const len = allInputTables.length;
    for (; i < len; i++) {
      const data = allInputTables[i].data;
      const inputData = {};

      for (let key in data) inputData[key] = data[key];

      result.data.push(inputData);
    }

    return result;
  };

  node.setJson = function (data) {
    //meta
    nodeOptions.querySelector("input[name=label]").value = data.meta.label;
    nodeOptions.querySelector("input[name=name]").value = data.meta.name;
    const nInputs = data.data.length;
    nodeOptions.querySelector("input[name=nInputs]").value = nInputs;

    //data
    nodeInput.removeInput();
    for (let i = 0; i < nInputs; i++) {
      const dataset = data.data[i];
      const inputTable = nodeInput.addInput();

      for (let key in dataset) {
        const seterName = "set" + key[0].toUpperCase() + key.substr(1);
        let setFunction = inputTable[seterName];
        if (typeof setFunction !== "function") {
          console.error("Default input seter " + seterName + " not found.");
          continue;
        }
        setFunction(dataset[key]);
      }
    }
  };

  /**
   * Add a new input on the end
   * @returns {Element}
   * Wrapper with some inputs
   */
  nodeInput.addInput = function () {
    //table layout for input adjustments
    const table = document.createElement("table");
    table.data = {};

    let labelInput,
      nameInput,
      typeSelect,
      weekdaySelect,
      contactInput,
      autooptinInput,
      optionInput,
      requiredInput,
      oneMoreWeekInput,
      minlengthInput,
      maxlengthInput,
      minInput,
      maxInput,
      minDateInput,
      maxDateInput,
      inDateInput,
      endDaysInput,
      minAgeInput,
      patternInput,
      emptySelectInput;

    table.setLabel = function (val) {
      table.data.label = val;
      labelInput.value = val;
    };

    table.setName = function (val) {
      val = validName(val);

      table.data.name = val;
      nameInput.value = val;
    };
    table.setDisabled = function (val) {
      table.data.disabled = val;
      requiredInput.disabled = val;
    };
    table.setType = function (val) {
      const options = typeSelect.options;

      //get index of target option
      for (var i = 0, len = options.length; i < len; i++) {
        if (options[i].value === val) break;
      }
      if (i >= len) {
        console.error(val + " not found for default input");
        return;
      }
      const targetIndex = i;
      const currentIndex = typeSelect.selectedIndex;

      // handle input types different ...
      if (val === "select") {
        optionInput.required = true;
      } else if (optionInput) {
        optionInput.required = false;
      }

      val = val !== "iban" ? val : "iban";

      table.setAttribute("type", val); //for css
      table.data.type = val;
      // call constraints
      constraints.callAll();

      //avoid potental infinite loops
      if (targetIndex === currentIndex) return;

      typeSelect.selectedIndex = targetIndex;
    };

    table.setOptions = function (val) {
      table.data.options = val;
      optionInput.value = val;
    };

    table.setRequired = function (val) {
      table.data.required = val;
      requiredInput.checked = val;
    };

    table.setOneMoreWeek = function (val) {
      table.data.oneMoreWeek = val;
      oneMoreWeekInput.checked = val;
    };

    table.setMinLength = function (val) {
      if (val !== null && val !== "") {
        val = Math.max(1, val);
      }

      table.data.minLength = val;
      minlengthInput.value = val;
    };

    table.setMaxLength = function (val) {
      if (val !== null && val !== "") {
        val = Math.max(1, val);
      }

      table.data.maxLength = val;
      maxlengthInput.value = val;
    };

    table.setMin = function (val) {
      val = parseFloat(val);
      if (Number.isNaN(val)) return;
      table.data.min = val;
      minInput.value = val;
    };

    table.setMax = function (val) {
      val = parseFloat(val);
      if (Number.isNaN(val)) return;
      table.data.max = val;
      maxInput.value = val;
    };

    table.setMinDate = function (val) {
      table.data.minDate = val;
      minDateInput.value = val;
    };

    table.setMaxDate = function (val) {
      table.data.maxDate = val;
      maxDateInput.value = val;
    };

    table.setEmptySelect = function (val) {
      table.data.emptySelect = val;
      emptySelectInput.checked = val;
    };

    table.setInDate = function (val) {
      if (val < 0) val = 0;
      if (val > 365) val = 365;
      if (val) {
        minAgeInput.disabled = true;
        minDateInput.disabled = true;
        maxDateInput.disabled = true;
      } else {
        minAgeInput.disabled = false;
        minDateInput.disabled = false;
        maxDateInput.disabled = false;
      }
      table.data.inDate = val;
      inDateInput.value = val;
    };

    table.setEndDays = function (val) {
      if (val < 0) val = 0;

      minAgeInput.disabled = val !== null;

      table.data.endDays = val;
      endDaysInput.value = val;
    };

    table.setStartWeekday = function (val) {
      const oneMoreWeekRow =
        weekdaySelect.parentElement.parentElement.parentElement.querySelector(
          ".one-more-week"
        );

      if (val) {
        oneMoreWeekRow.style = "";
      } else {
        oneMoreWeekRow.style = "display: none;";
        oneMoreWeekInput.checked = false;
      }

      let weekdayIndex = weekdays.findIndex((weekday) => weekday === val);

      if (weekdayIndex > 0) {
        weekdaySelect.selectedIndex = weekdayIndex;
      }

      table.data.startWeekday = val;
    };

    table.setMinAge = function (val) {
      if (val < 0) val = 0;
      if (val > 99) val = 99;
      if (val) {
        inDateInput.disabled = true;
        minDateInput.disabled = true;
        maxDateInput.disabled = true;
      } else {
        inDateInput.disabled = false;
        minDateInput.disabled = false;
        maxDateInput.disabled = false;
      }
      table.data.minAge = val;
      minAgeInput.value = val;
    };
    table.setPattern = function (val) {
      if (val === null) {
        table.data.pattern = null;
        patternInput.value = null;
        patternInput.setCustomValidity("");
        return;
      }

      try {
        new RegExp(val);
        //if no error thrown, pattern is valid
        table.data.pattern = val;
        patternInput.value = val;
        patternInput.setCustomValidity("");
      } catch (e) {
        snackbar.show({ message: e.message });
        patternInput.setCustomValidity(e.message);
        throw e;
      }
    };

    table.setContact = function (val) {
      table.data.contact = val;
      contactInput.checked = val;
    };

    table.setAutooptin = function (val) {
      table.data.autooptin = val;
      autooptinInput.checked = val;
    };

    /**
     *
     * @type Element
     */
    let tr, td;

    // -- label / placeholder --
    td = getTd(lng.get("form-attribute-label"));
    tr.setAttribute("attr", "label");
    labelInput = document.createElement("input");
    labelInput.type = "text";
    labelInput.required = true;
    td.appendChild(labelInput);
    labelInput.addEventListener("change", (e) =>
      table.setLabel(labelInput.value)
    );

    // -- name --
    td = getTd(lng.get("form-attribute-export"));
    tr.setAttribute("attr", "name");
    nameInput = document.createElement("input");
    nameInput.type = "text";
    nameInput.name = "name"; //important for validation
    nameInput.required = true;
    td.appendChild(nameInput);
    let allowedChars =
      "QWERTZUIOPASDFGHJKLYXCVBNMqwertzuiopasdfghjklyxcvbnmüäöÜÄÖß1234567890-_ ";
    allowedChars = allowedChars.split("");
    nameInput.addEventListener("change", (e) => table.setName(nameInput.value));

    // -- type --
    td = getTd(lng.get("form-input-default-type"));
    tr.setAttribute("attr", "type");
    typeSelect = document.createElement("select");
    td.appendChild(typeSelect);
    const types = ["text", "number", "email", "date", "select", "tel", "iban"];
    types.map((t) => {
      const option = document.createElement("option");
      option.value = t;
      option.textContent = lng.get("form-input-default-" + t);
      typeSelect.appendChild(option);
    });
    typeSelect.addEventListener("change", (e) =>
      table.setType(typeSelect.value)
    );
    table.setType(typeSelect.value);

    //-- contact -- (special field just for type email)
    td = getTd(lng.get("form-input-default-contact"));
    td.classList.add("hide");
    tr.setAttribute("attr", "contact");
    contactInput = document.createElement("input");
    contactInput.type = "checkbox";
    td.appendChild(contactInput);
    contactInput.addEventListener("change", (e) => {
      table.setContact(contactInput.checked);
      constraints.callAll();
      const req =
        contactInput.parentElement.parentElement.parentElement.querySelector(
          "[attr=required] input"
        );
      /*if(contactInput.checked){
                table.setRequired(true);
                table.setDisabled(true);
            } else {
                table.setDisabled(false);
            }*/
    });

    //-- autooptin -- (special field just for email)
    td = getTd(lng.get("form-input-default-autooptin"));
    td.classList.add("hide");
    tr.setAttribute("attr", "autooptin");
    autooptinInput = document.createElement("input");
    autooptinInput.type = "checkbox";
    td.appendChild(autooptinInput);
    autooptinInput.addEventListener("change", (e) => {
      table.setAutooptin(autooptinInput.checked);
    });

    // -- options --
    td = getTd(lng.get("form-attribute-option"));
    tr.setAttribute("attr", "options");
    optionInput = document.createElement("input");
    optionInput.type = "text";
    td.appendChild(optionInput);
    optionInput.addEventListener("change", (e) =>
      table.setOptions(optionInput.value)
    );

    // -- required --
    td = getTd(lng.get("form-attribute-required"));
    tr.setAttribute("attr", "required");
    requiredInput = document.createElement("input");
    requiredInput.type = "checkbox";
    td.appendChild(requiredInput);
    requiredInput.addEventListener("change", (e) =>
      table.setRequired(requiredInput.checked)
    );

    // -- minlength --
    td = getTd(lng.get("form-input-default-minlength"));
    tr.setAttribute("attr", "minLength");
    minlengthInput = document.createElement("input");
    minlengthInput.type = "number";
    td.appendChild(minlengthInput);
    minlengthInput.addEventListener("change", (e) =>
      table.setMinLength(minlengthInput.value)
    );

    // -- maxlength --
    td = getTd(lng.get("form-input-default-maxlength"));
    tr.setAttribute("attr", "maxLength");
    maxlengthInput = document.createElement("input");
    maxlengthInput.type = "number";
    td.appendChild(maxlengthInput);
    maxlengthInput.addEventListener("change", (e) =>
      table.setMaxLength(maxlengthInput.value)
    );

    // -- min --
    td = getTd(lng.get("form-input-default-min"));
    tr.setAttribute("attr", "min");
    minInput = document.createElement("input");
    minInput.type = "number";
    minInput.step = "any";
    td.appendChild(minInput);
    minInput.addEventListener("change", (e) => table.setMin(minInput.value));

    // -- max --
    td = getTd(lng.get("form-input-default-max"));
    tr.setAttribute("attr", "max");
    maxInput = document.createElement("input");
    maxInput.type = "number";
    maxInput.step = "any";
    td.appendChild(maxInput);
    maxInput.addEventListener("change", (e) => table.setMax(maxInput.value));

    // -- startdate --
    td = getTd(lng.get("form-input-default-startdate"));
    tr.setAttribute("attr", "date_min");
    minDateInput = document.createElement("input");
    minDateInput.type = "date";
    td.appendChild(minDateInput);
    minDateInput.addEventListener("change", (e) =>
      table.setMinDate(minDateInput.value)
    );

    // -- enddate --
    td = getTd(lng.get("form-input-default-enddate"));
    tr.setAttribute("attr", "date_max");
    maxDateInput = document.createElement("input");
    maxDateInput.type = "date";
    td.appendChild(maxDateInput);
    maxDateInput.addEventListener("change", (e) =>
      table.setMaxDate(maxDateInput.value)
    );

    // -- startdatein --
    td = getTd(lng.get("form-input-default-startdatein"));
    tr.setAttribute("attr", "date_min_in");
    inDateInput = document.createElement("input");
    inDateInput.type = "number";
    td.appendChild(inDateInput);
    inDateInput.addEventListener("change", (e) =>
      table.setInDate(inDateInput.value)
    );

    // -- minage --
    td = getTd(lng.get("form-input-default-minage"));
    tr.setAttribute("attr", "date_minage");
    minAgeInput = document.createElement("input");
    minAgeInput.type = "number";
    td.appendChild(minAgeInput);
    minAgeInput.addEventListener("change", (e) =>
      table.setMinAge(minAgeInput.value)
    );

    // -- weekday --
    td = getTd("Lieferbeginn am Wochentag");
    tr.setAttribute("attr", "startdate_weekday");
    weekdaySelect = document.createElement("select");
    td.appendChild(weekdaySelect);
    weekdays.map((weekday) => {
      const option = document.createElement("option");
      option.value = weekday;
      option.textContent = lng.get(weekday);
      weekdaySelect.appendChild(option);
    });
    weekdaySelect.addEventListener("change", (e) =>
      table.setStartWeekday(weekdaySelect.value)
    );

    // -- + 1 week --
    td = getTd(lng.get("form-attribute-one-more-week"));
    tr.setAttribute("attr", "one-more-week");
    tr.classList.add("one-more-week");
    tr.style = "display: none;";
    oneMoreWeekInput = document.createElement("input");
    oneMoreWeekInput.type = "checkbox";
    oneMoreWeekInput.checked = false;
    td.appendChild(oneMoreWeekInput);
    oneMoreWeekInput.addEventListener("change", (e) =>
      table.setOneMoreWeek(oneMoreWeekInput.checked)
    );

    // -- enddatum in x days --
    td = getTd("Lieferende in X Tagen");
    tr.setAttribute("attr", "enddate_days");
    endDaysInput = document.createElement("input");
    endDaysInput.type = "number";
    td.appendChild(endDaysInput);
    endDaysInput.addEventListener("change", (e) =>
      table.setEndDays(endDaysInput.value)
    );

    // -- pattern --
    td = getTd(lng.get("form-input-default-regex"));
    tr.setAttribute("attr", "regex");
    patternInput = document.createElement("input");
    patternInput.type = "text";
    td.appendChild(patternInput);
    patternInput.addEventListener("change", (e) =>
      table.setPattern(patternInput.value)
    );

    // -- emptySelect --
    td = getTd(lng.get("form-input-default-emptySelect"));
    tr.setAttribute("attr", "emptySelect");
    emptySelectInput = document.createElement("input");
    emptySelectInput.type = "checkbox";
    td.appendChild(emptySelectInput);
    emptySelectInput.addEventListener("change", (e) =>
      table.setEmptySelect(emptySelectInput.checked)
    );

    nodeInput.appendChild(table);

    /**
     * Append an new tr to table containing 2 td.
     * First td will have textContent with <i>label</i>.
     * Second td will be returned;
     * @param {string} label
     * @returns {Element}
     */
    function getTd(label) {
      tr = document.createElement("tr");
      table.appendChild(tr);

      td = document.createElement("td");
      tr.appendChild(td);
      td.textContent = label;

      td = document.createElement("td");
      tr.appendChild(td);
      return td;
    }

    return table;
  };

  /**
   * Remove last input
   * @returns {undefined}
   */
  nodeInput.removeInput = function () {
    const all = nodeInput.children;
    if (all.length === 0) return;
    nodeInput.removeChild(all[all.length - 1]);
  };

  addGenericOption("label");
  addGenericOption("name");
  nodeOptions.insertAdjacentHTML(
    "beforeend",
    `
                    <tr>
                        <td>${lng.get("form-input-default-nInputs")}</td>
                        <td><input type="number" name="nInputs" size=3 min=1 max=3 value="1"></td>
                    </tr>
                `
  ); // normalerweise 4

  //if user change the nInputs value, add or remove inputs
  const nInput = nodeOptions.querySelector("input[name=nInputs]");
  nInput.addEventListener("change", function (e) {
    let n = this.value;
    const nCurrentInputs = nodeInput.children.length;

    //take care of min and max
    n = Math.max(this.min, n);
    n = Math.min(this.max, n);
    this.value = n;

    if (nCurrentInputs < n) {
      //add some inputs
      let diff = n - nCurrentInputs;
      while (diff-- > 0) nodeInput.addInput();
    } else {
      //remove some inputs
      for (let i = nCurrentInputs; i > n; i--) nodeInput.removeInput();
    }
  });
  nInput.dispatchEvent(new Event("change"));
}
